module.exports = __webpack_public_path__ + "assets/img/banner.ae4b7a9c.jpg";